<template>
    <v-toolbar flat height="65">
        <v-toolbar-title>
            <router-link to="/">
                <v-list-item class="listitem">
                    <Logo height="80" width="80"/>
                    <v-list-item-title class="title pointer">
                        TV MENDELU
                        <b v-if="currentEnv === 'development'" class="primary--text">DEV</b>
                        <b v-else-if="currentEnv === 'debug'" class="error--text">DEBUG</b>
                    </v-list-item-title>
                </v-list-item>
            </router-link>
        </v-toolbar-title>
    </v-toolbar>

</template>

<script>
    import Logo from '../assets/logo.svg';
    import {config} from '../config';

    export default {
        name: 'Top',

        components: {Logo},

        data: () => ({
            logo: require('@/assets/logo.svg')
        }),

        computed: {
            currentEnv() {
                return config.env;
            }
        }
    }
</script>

<style scoped>
    .v-icon {
      margin-right: 10px;
    }

    a.router-link-active {
        text-decoration: none;
    }

    .title {
        font-size: 20px;
        font-weight: 600;
    }

    .listitem {
        padding: 0px;
    }

    @media only screen and (max-width: 820px) {
        .listitem {
          margin-left: 15px;
        }
    }

    header {
        border-bottom: 2px solid #c4c4c4 !important;
    }

    .no-uppercase {
        text-transform: none;
    }

    .v-toolbar {
        /* idk why but toolbar has this default settings for flex grow and shrink that must be overriden to avoid having toolbar over half a page */
        flex-grow: unset;
        flex-shrink: unset;
    }

</style>
